import { React, useState, useEffect }  from "react";
import "./CreateNotificationModal.css";

import axios from 'axios';
import { API_BASE_URL } from '../../Variables';

/**
 * Create Notification Modal
 *
 * @param {*} onClose - Function to close the modal
 * @param {*} onSave - Function to call when the notification is saved
 * @returns 
 */
function CreateNotificationModal({ onClose, onSave }) {
  const [title, setTitle] = useState("");
  const [message, setMessage] = useState("");
  const [notificationType, setNotificationType] = useState("update");
  const [sendToAll, setSendToAll] = useState(false);
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [error, setError] = useState("");

  // Fetch all users
  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/users/all-users`, {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
          params: {
            sortBy: "username",
            sortOrder: "asc",
          },
        });

        setUsers(response.data.users);
      } catch (err) {
        setError("Failed to load users.");
      }
    };

    fetchUsers();
  }, []);

  // Save the notification
  const handleSave = async () => {
    if (!title || !message) {
      setError("Title and Message are required.");
      return;
    }

    if (!sendToAll && !selectedUser) {
      setError("Please select a user to send notification to.");
      return;
    }

    try {
      const payload = {
        title,
        message,
        notification_type: notificationType,
        user_id: sendToAll ? null : selectedUser,
      };

      await axios.post(`${API_BASE_URL}/notifications`, payload, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });

      onSave(); // Notify parent component that the notification was saved
    } catch (err) {
      setError("Failed to create notification. Please try again.");
    }
  };

  return (
    <div className="modal-overlay">
      <div className="review-modal">
        <h2>Create Notification</h2>

        <div className="modal-section">
          <label>Title:</label>
          <input
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            placeholder="e.g., Huge Update!"
          />
        </div>

        <div className="modal-section">
          <label>Message:</label>
          <textarea
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            placeholder="Message to users..."
          />
        </div>

        <div className="modal-section">
          <label>Notification Type:</label>
          <select
            value={notificationType}
            onChange={(e) => setNotificationType(e.target.value)}
          >
            <option value="update">Update</option>
            <option value="warning">Warning</option>
            <option value="info">Info</option>
          </select>
        </div>

        <div className="modal-section">
          <label>Send To:</label>
          <div>
            <label>
              <input
                type="checkbox"
                checked={sendToAll}
                onChange={(e) => {
                  setSendToAll(e.target.checked);
                  if (e.target.checked) setSelectedUser(null);
                }}
              />
              All Users
            </label>
          </div>
          {!sendToAll && (
            <select
              value={selectedUser || ""}
              onChange={(e) => setSelectedUser(e.target.value)}
            >
              <option value="" disabled>Select a user</option>
              {users.length === 0 && <option disabled>Loading users...</option>}

              {users.length > 0 && users.map((user) => (
                <option key={user.id} value={user.id}>
                  {user.username} ({user.email})
                </option>
              ))}
            </select>
          )}
        </div>

        {error && <p className="error">{error}</p>}

        <div className="modal-buttons">
          <button onClick={handleSave} className="tertiary-button">Save</button>
          <button onClick={onClose} className="secondary-button">Cancel</button>
        </div>
      </div>
    </div>
  );
}

export default CreateNotificationModal;
